import { downloadCsv, getNewLine } from "../utilities";

const escapeValue = value => (value.includes(",") ? `"${value}"` : value);

export const serializeSettings = (settings, prefixWithNewLine = false) => {
  if (!settings) {
    return;
  }

  const newLine = getNewLine();

  return (
    (prefixWithNewLine ? newLine : "") +
    newLine +
    "Settings" +
    newLine +
    Object.keys(settings)
      .map(key => `${key},${settings[key]}`)
      .join(newLine)
  );
};

export const downloadAnnotatedCsv = (csv, filename) => {
  const newLine = getNewLine();

  const annotatedCsv =
    csv +
    (csv ? newLine + newLine : csv) +
    "Note: Numbers have not been not rounded to facilitate calculations. This detail does not indicate precision. Only numbers rounded to 3 significant digits should be presented.";

  downloadCsv(annotatedCsv, filename);
};

export default (
  categories,
  rowKey,
  columnKey,
  rowTitles,
  columnTitles,
  rowNames,
  columnNames,
  data,
  settings,
  na = ""
) => {
  const newLine = getNewLine();

  rowTitles = rowTitles || rowNames;
  columnTitles = columnTitles || ["", ...columnNames];
  na = escapeValue(na);

  let csv = "";

  if (categories) {
    csv += categories.map(s => escapeValue(s)).join(",") + newLine;
  }

  csv += columnTitles.map(s => escapeValue(s)).join(",") + newLine;

  for (let r = 0; r < rowNames.length; r++) {
    const rowName = rowNames[r];

    csv += escapeValue(rowTitles[r]);

    for (let c = 0; c < columnNames.length; c++) {
      const columnName = columnNames[c];

      const record = data.find(
        datum => datum[rowKey] === rowName && datum[columnKey] === columnName
      );

      csv += "," + (record == null ? na : record.value);
    }

    csv += newLine;
  }

  csv += serializeSettings(settings);

  return csv;
};
